import * as navigation from 'Navigation';

import RequestV2DefinitionFileState from './RequestV2DefinitionFileState';

export default class RequestV2DefinitionTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Request Template',
      closeable: false,
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    };
  }

  getRequestV2DefinitionFileState(): RequestV2DefinitionFileState {
    return this.get('requestV2DefinitionFileState');
  }
}
